import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../store";
import { Loader } from "../../components/loader";
import { createAnimalType } from "../../actions/addAnimalType";
import { forceInputUppercase } from "../../utils/helper";

const $ = window.$;
class AddAnimalType extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        animal: "",
        loading: false,
        inputNotValid: false
      };
    }
    handleChange = event => {
      forceInputUppercase(event);
      const value = event.target.value;
      this.setState({
        ...this.state,
        [event.target.name]: value
      });
    };
    submitAnimalType(e) {
      this.setState({ loading: true });
      let data = {
        type: this.state.animal,
        PetShopId: this.props.petShop.currentPetshop.id
      };
  
      let valid = this.state.animal.length > 0;
  
      if (valid) {
        this.props.createAnimalType(data);
      } else {
        e.preventDefault();
        NotificationManager.warning("Animal type can not be empty.");
        this.setState({ loading: false });
        this.setState({ inputNotValid: true });
      }
    }
  
    closeModal = () => {
      $("#add_animal_type").modal("hide");
      this.resetState();
    };
    resetState = () => {
      this.setState({
        animal: "",
        loading: false,
        inputNotValid: false
      });
    };
    componentWillReceiveProps = nextProps => {
      if (nextProps.animalType && this.props.animalType !== nextProps.animalType) {
        this.setState({ animal: "", loading: false });
        NotificationManager.success("Animal Type Added");
        $("#add_animal_type").modal("hide");
      }
      if (nextProps.animalTypeError && this.props.animalTypeError !== nextProps.animalTypeError) {
        this.setState({ animal: "", loading: false });
        if(nextProps.animalTypeError.message && nextProps.animalTypeError.message.name === 'SequelizeUniqueConstraintError')
          NotificationManager.error("Animal type already exists");
        else 
          NotificationManager.error("Failed to add Animal Type.");
        
        $("#add_animal_type").modal("hide");
      }
    };
  
    render() {
      return (
        <div
          className="modal fade show"
          id="add_animal_type"
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <form className="m-form">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    New Animal Type
                  </h5>
                  <button
                    type="button"
                    className="close"
                    onClick={this.closeModal}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="m-form__section m-form__section--first">
                        {/* <div className="m-form__heading">
                                      <h3 className="m-form__heading-title">User Details</h3>
                                  </div> */}
  
                        <div className="form-group m-form__group row">
                          <label className="col-xl-3 col-lg-3 col-form-label">
                            Animal Type:
                          </label>
                          <div className="col-xl-9 col-lg-9">
                            <input
                              type="text"
                              name="animal"
                              onChange={e => this.handleChange(e)}
                              value={this.state.animal}
                              className="form-control m-input"
                              placeholder=""
                            />
                            <span
                              className={
                                this.state.inputNotValid
                                  ? "m-form__help_danger"
                                  : "m-form__help"
                              }
                            >
                              Please enter animal type
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  {this.state.loading == false ? (
                    <div>
                      <button
                        type="button"
                        className="btn btn-secondary m-btn--pill mx-2"
                        onClick={this.closeModal}
                      >
                        Close
                      </button>
                      <button
                        onClick={(e) => this.submitAnimalType(e)}
                        type="submit"
                        className="btn btn-primary m-btn--pill"
                      >
                        Submit
                      </button>
                    </div>
                  ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      );
    }
  }
  
  const mapStateToProps = state => ({
    petShop: state.petShopReducer,
    animalType: state.addAnimalTypeReducer.setAnimalType,
    animalTypeError: state.addAnimalTypeReducer.setAnimalTypeError
  });
  
  const mapDispatchToProps = dispatch => ({
    createAnimalType: pet => {
      dispatch(createAnimalType(pet));
    }
  });
  
  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AddAnimalType)
  );
